import { nanoid } from 'nanoid'
import { getCanvasCoord, getPathInitialData } from '../../utils/utils.js'

/**
 * 펜 도구 사용 시 (mousedown or touchstart)
 * - 새 path 객체 생성
 * - pressure, cap 설정
 * - 상태 업데이트 및 동기화
 */
export const handlePenDown = (e, state) => {
  const {
    paths,
    currentPath,
    currentPathId,
    scope,
    translate,
    selectedTool,
    setIsCapTrue,
    setIsSimulatePressure,
    thicknessVal,
    opacityVal,
    colorVal,
    clientCoord,
    previousPenPoint,
    // 동시편집
    triggerAddPath,
  } = state

  // 펜 설정: pressure simulation & cap 여부 설정
  setIsSimulatePressure(selectedTool === 'pen-pressure')
  setIsCapTrue(selectedTool !== 'pen-highlight')

  // 현재 마우스/터치 좌표를 캔버스 좌표로 변환
  const canvasCoord = getCanvasCoord(clientCoord, translate, scope)

  // 새로운 path ID 생성
  const t = nanoid()
  currentPathId.current = t

  // 현재 경로 저장
  currentPath.current = getPathInitialData(
    'draw',
    Object.keys(paths).length,
    canvasCoord.x,
    canvasCoord.y,
    0,
    0,
    0,
    0,
    thicknessVal[selectedTool],
    opacityVal[selectedTool],
    colorVal[selectedTool],
    1,
    colorVal[selectedTool],
    e.pressure,
    false,
    1
  )
  previousPenPoint.current = canvasCoord

  // 상태 업데이트
  // paths[t] = currentPath.current
  triggerAddPath(t, currentPath.current)
}
